const isFiniteNumber = (value) => Number.isFinite(Number(value));

const encodeCoordPair = (lat, lon) => encodeURIComponent(`${lat},${lon}`);

const detectWebView = (userAgent = '') => (
  /(\bwv\b|WebView|; wv\)|FBAN|FBAV|Instagram|Line|Twitter)/i.test(userAgent)
);

export const buildMapsLinks = (position) => {
  if (!isFiniteNumber(position?.latitude) || !isFiniteNumber(position?.longitude)) {
    return null;
  }

  const latitude = Number(position.latitude);
  const longitude = Number(position.longitude);
  const heading = isFiniteNumber(position?.course) ? Number(position.course) : 0;

  const encodedPoint = encodeCoordPair(latitude, longitude);

  return {
    googleMaps: `https://www.google.com/maps/search/?api=1&query=${encodedPoint}`,
    appleMaps: `https://maps.apple.com/?ll=${encodedPoint}`,
    streetView: `https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=${encodedPoint}&heading=${encodeURIComponent(heading)}`,
    waze: `https://waze.com/ul?ll=${encodedPoint}&navigate=yes`,
    googleShare: `https://www.google.com/maps/?q=${encodedPoint}`,
  };
};

export const reportMapOpenFailure = ({ source, provider, url, deviceId, positionId }) => {
  if (typeof window === 'undefined') return;

  const payload = {
    event: 'map_open_failed',
    source,
    provider,
    url,
    deviceId,
    positionId,
    timestamp: new Date().toISOString(),
    context: {
      userAgent: window.navigator?.userAgent || '',
      platform: window.navigator?.platform || '',
      isWebView: detectWebView(window.navigator?.userAgent || ''),
      isStandalone: window.matchMedia?.('(display-mode: standalone)')?.matches || false,
    },
  };

  window.dispatchEvent(new CustomEvent('telemetry:map-open-failed', { detail: payload }));

  if (window.navigator?.sendBeacon) {
    const blob = new Blob([JSON.stringify(payload)], { type: 'application/json' });
    window.navigator.sendBeacon('/api/telemetry/frontend', blob);
    return;
  }

  fetch('/api/telemetry/frontend', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
    keepalive: true,
  }).catch(() => {});
};
